<template>
  <div class="molded-seat-step-seven">
    <v-layout justify-space-between>
      <v-flex sm6>
        <v-switch
          v-model="form.tablet_module.idc_tablet"
          hide-details
          label="Tablette :"
          class="title"
          @change="clearTabletFields"
        />
        <v-radio-group
          v-model="form.tablet_module.type"
          hide-details
          row
          class="mb-4"
          :disabled="!form.tablet_module.idc_tablet"
        >
          <v-radio
            label="Existant"
            value="EXISTING"
          />
          <v-radio
            label="Nouveau"
            value="CUSTOM_MADE"
          />
        </v-radio-group>

        <v-layout wrap>
          <v-radio-group
            v-model="form.tablet_module.matter"
            hide-details
            row
            class="mb-4"
            :disabled="!form.tablet_module.idc_tablet"
          >
            <v-radio
              label="Plexi"
              value="PLEXI"
            />
            <v-radio
              label="PVC"
              value="PVC"
            />
          </v-radio-group>
          <v-checkbox
            v-model="form.tablet_module.idc_standard"
            hide-details
            label="Standard"
            class="mr-4 mt-2"
            :disabled="!form.tablet_module.idc_tablet"
          />
          <v-radio-group
            v-model="form.tablet_module.tablet_type"
            hide-details
            row
            class="mb-4"
            :disabled="!form.tablet_module.idc_tablet"
          >
            <v-radio
              label="Bugle"
              value="BUGLE"
            />
            <v-radio
              label="Insert central"
              value="INSERT_CENTRAL"
            />
          </v-radio-group>
        </v-layout>

        <h4 class="mt-8">
          RETOUR :
        </h4>
        <v-radio-group
          v-model="form.tablet_module.comeback"
          row
          :disabled="!form.tablet_module.idc_tablet"
        >
          <v-radio
            label="Total"
            value="TOTAL"
          />
          <v-radio
            label="Sans retour"
            value="NO_RETURN"
          />
          <v-radio
            label="Coude libre"
            value="FREE_ELBOW"
          />
        </v-radio-group>
      </v-flex>

      <v-flex
        column
        sm6
      >
        <div class="content img1">
          <div class="img-container">
            <img src="@/assets/img/schema_verticalisateur_4a.svg">
            <v-text-field
              v-model="form.tablet_module.a"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Tablette) A') }"
              data-vv-name="(Tablette) A"
              outlined
              type="number"
              style="top: -0.2%;left: 54.2%;"
              s
              height="100%"
              :disabled="!form.tablet_module.idc_tablet"
            />
            <v-text-field
              v-model="form.tablet_module.b"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Tablette) B') }"
              data-vv-name="(Tablette) B"
              outlined
              type="number"
              style="top: 38.1%;left: 44.1%;"
              height="100%"
              :disabled="!form.tablet_module.idc_tablet"
            />
            <v-text-field
              v-model="form.tablet_module.c"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Tablette) C') }"
              data-vv-name="(Tablette) C"
              outlined
              type="number"
              style="top: 65.4%;left: 28.4%;"
              height="100%"
              :disabled="!form.tablet_module.idc_tablet"
            />
            <v-text-field
              v-model="form.tablet_module.d"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Tablette) D') }"
              data-vv-name="(Tablette) D"
              outlined
              type="number"
              style="top: 86.4%;left: 54.2%;"
              height="100%"
              :disabled="!form.tablet_module.idc_tablet"
            />
            <v-text-field
              v-model="form.tablet_module.e"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Tablette) E') }"
              data-vv-name="(Tablette) E"
              outlined
              type="number"
              style="top: 65.4%;left: 81.1%;"
              height="100%"
              :disabled="!form.tablet_module.idc_tablet"
            />
            <v-text-field
              v-model="form.tablet_module.f"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Tablette) F') }"
              data-vv-name="(Tablette) F"
              outlined
              type="number"
              style="top: 61.6%;left: 0.1%;"
              height="100%"
              :disabled="!form.tablet_module.idc_tablet"
            />
          </div>
        </div>
      </v-flex>
    </v-layout>
    <v-layout
      justify-space-between
      mt-12
    >
      <v-flex sm6>
        <v-switch
          v-model="form.leg_segment_module.idc_leg_segment"
          hide-details
          label="Segments Jambiers :"
          class="title"
          @change="clearLegFields"
        />
        <v-radio-group
          v-model="form.leg_segment_module.position"
          hide-details
          class="mb-4"
          :disabled="!form.leg_segment_module.idc_leg_segment"
        >
          <v-layout
            class="checkbox-input-container mt-2 mb-4"
            align-center
          >
            <v-flex sm5>
              <v-radio
                label="Sur socle"
                value="ON_SOCLE"
              />
            </v-flex>
            <v-flex
              sm7
              class="checkbox-input visible"
            >
              <v-select
                v-model="form.leg_segment_module.right"
                :items="legSegmentModule.right"
                item-text="label"
                item-value="value"
                filled
                clearable
                hide-details
                :disabled="!form.leg_segment_module.idc_leg_segment"
                @click:clear="
                  $nextTick(() => (form.leg_segment_module.right = null))
                "
              />
            </v-flex>
          </v-layout>

          <v-layout
            class="checkbox-input-container mt-2 mb-4"
            align-center
          >
            <v-flex sm5>
              <v-radio
                label="Châssis"
                value="EXISTING"
              />
            </v-flex>
            <v-flex
              sm7
              class="checkbox-input visible"
            >
              <v-select
                v-model="form.leg_segment_module.left"
                :items="legSegmentModule.left"
                item-text="label"
                item-value="value"
                filled
                clearable
                hide-details
                :disabled="!form.leg_segment_module.idc_leg_segment"
                @click:clear="
                  $nextTick(() => (form.leg_segment_module.left = null))
                "
              />
            </v-flex>
          </v-layout>
        </v-radio-group>

        <v-layout wrap>
          <v-textarea
            v-model="form.leg_segment_module.comment"
            filled
            name="Ajouter un commentaire :"
            label="Ajouter un commentaire :"
            :disabled="!form.leg_segment_module.idc_leg_segment"
          />
        </v-layout>
      </v-flex>

      <v-flex
        column
        sm6
      >
        <div class="content img2">
          <div class="img-container">
            <img src="@/assets/img/schema_siegemoule_8b.svg">
            <v-text-field
              v-model="form.leg_segment_module.a"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Segments Jambiers) A') }"
              data-vv-name="(Segments Jambiers) A"
              outlined
              type="number"
              :rules="[v => !v || v.length <= 6 || '']"
              style="top: 0.3%;left: 24.8%;"
              height="100%"
              :disabled="!form.leg_segment_module.idc_leg_segment"
            />

            <v-text-field
              v-model="form.leg_segment_module.b"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Segments Jambiers) B') }"
              data-vv-name="(Segments Jambiers) B"
              outlined
              type="number"
              style="top: 42.1%;left: 80.1%;"
              height="100%"
              :disabled="!form.leg_segment_module.idc_leg_segment"
            />

            <v-text-field
              v-model="form.leg_segment_module.c"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Segments Jambiers) C') }"
              data-vv-name="(Segments Jambiers) C"
              outlined
              type="number"
              style="top: 89.2%;left: 49.8%;"
              height="100%"
              :disabled="!form.leg_segment_module.idc_leg_segment"
            />
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MoldedSeatStepSeven",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      legSegmentModule: "dropdowns/getLegSegmentOptions"
    })
  },
  created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    // Clear tablet fields
    clearTabletFields() {
      this.form.tablet_module.type = null;
      this.form.tablet_module.idc_standard = false;
      this.form.tablet_module.matter = null;
      this.form.tablet_module.tablet_type = null;
      this.form.tablet_module.comeback = null;
      this.form.tablet_module.a = null;
      this.form.tablet_module.b = null;
      this.form.tablet_module.c = null;
      this.form.tablet_module.d = null;
      this.form.tablet_module.e = null;
      this.form.tablet_module.f = null;
    },

    // Clear leg segmentation fields
    clearLegFields() {
      this.form.leg_segment_module.position = null;
      this.form.leg_segment_module.right = null;
      this.form.leg_segment_module.left = null;
      this.form.leg_segment_module.a = null;
      this.form.leg_segment_module.b = null;
      this.form.leg_segment_module.c = null;
      this.form.leg_segment_module.comment = null;
    }
  }
};
</script>

<style lang="scss">
.molded-seat-step-seven {
  .content {
    display: flex;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
    &.img1 {
      .img-container {
        .v-input {
          width: 12.1%;
          height: 11.3%;
        }
      }
    }
    &.img2 {
      .img-container {
        .v-input {
          width: 19.5%;
          height: 8.8%;
        }
      }
    }
  }
  .checkbox-input-container {
    margin-top: 0;
    > div {
      &.checkbox-input {
        position: relative;
        top: 0;
        transform: none;
        margin-left: 15px;
        max-width: none !important;
        &:not(.visible) {
          display: none;
        }
      }
    }
  }
}
</style>
